import {
  MdAdd,
  MdAttachFile,
  MdOutlineDelete,
  MdOutlineFileDownload,
} from "react-icons/md";
import { bytesToMB } from "utils/helpers/files";
import Input from "../../Components/Input";

const DocumentItem = ({ item, onDownload, onFileRemove }) => {
  const fileName = item?.name || "";
  const extension = fileName.split(".").pop() || "";
  const size = item?.size ? `| ${bytesToMB(item.size)} Mo` : "";

  return (
    <div className="solyon-document">
      <MdAttachFile className="solyon-document__icon" size={24} />
      <div className="solyon-document__content">
        <div className="solyon-document__content--name">{fileName}</div>
        <div className="solyon-document__content--size">
          {`${extension} ${size}`}
        </div>
      </div>
      <div className="solyon-document__actions">
        <div
          className="solyon-document__action"
          onClick={() => onDownload(item)}
        >
          <MdOutlineFileDownload size={20} />
        </div>
        <div
          className="solyon-document__action solyon-document__action--danger"
          onClick={() => onFileRemove(item)}
        >
          <MdOutlineDelete size={20} />
        </div>
      </div>
    </div>
  );
};

const UploadPlaceholder = ({ label, items, onUpload, chargeMore }) => (
  <div className="solyon-document-uploader">
    <MdAttachFile className="solyon-document-uploader__icon" size={24} />
    <div className="solyon-document-uploader__content">
      <div className="solyon-document-uploader__content--name">{label}</div>
    </div>
    <Input
      type="file"
      showUploadList={false}
      fileList={items}
      onUpload={onUpload}
    >
      <div className="solyon-document-uploader__action">
        <MdAdd />
        <span>
          {chargeMore ? "Ajouter un autre document" : "Ajouter un document"}
        </span>
      </div>
    </Input>
  </div>
);

const DocumentUpload = ({
  items = [],
  label,
  onDownload,
  onUpload,
  onFileRemove,
  isMultiple,
}) => {
  if (!items.length) {
    return (
      <UploadPlaceholder label={label} items={items} onUpload={onUpload} />
    );
  }

  if (isMultiple) {
    return (
      <>
        <UploadPlaceholder
          label={label}
          items={items}
          onUpload={onUpload}
          chargeMore
        />
        {items.map((item) => (
          <DocumentItem
            key={item?.uid || item?.name}
            item={item}
            onDownload={onDownload}
            onFileRemove={onFileRemove}
          />
        ))}
      </>
    );
  }

  return items.map((item) => (
    <DocumentItem
      key={item?.uid || item?.name}
      item={item}
      onDownload={onDownload}
      onFileRemove={onFileRemove}
    />
  ));
};

export default DocumentUpload;
